import "@legacy/entrypoints/filter-list";
import "@legacy/entrypoints/product-card";
import "@legacy/entrypoints/product-card-list";
import "@legacy/entrypoints/slider";
import "@legacy/entrypoints/cart";

import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

document.querySelectorAll(".home-page .popular-category-section").forEach((slider) => {
    const swiperElement = slider.querySelector<HTMLElement>(".swiper");
    if (!swiperElement) {
        console.error("Can't find a swiper element for", slider);
        return;
    }

    const nextButton = slider.querySelector<HTMLElement>('.swiper-button-next');
    const prevButton = slider.querySelector<HTMLElement>('.swiper-button-prev');

    new Swiper(swiperElement, {
        modules: [Navigation],
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 16,
        breakpoints: {
            1200: {
                slidesPerView: 6,
                slidesPerGroup: 6,
            }
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
    });
});

new Swiper("#discounts .swiper", {
    modules: [Navigation],
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 16,
    breakpoints: {
        1200: {
            slidesPerView: 6,
            slidesPerGroup: 6,
        }
    },
    navigation: {
        nextEl: "#discounts .swiper-button-next",
        prevEl: "#discounts .swiper-button-prev",
    },
});

